export default __webpack_public_path__ + "static/media/integrity-logo.c5623cc3.svg";